import React from 'react';
import { Send } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * ChatInput - Text input and send button for chat
 */
export default function ChatInput({
  value,
  onChange,
  onSend,
  onFocus,
  isLoading,
  inputRef
}) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <div
      ref={inputRef}
      style={{
        padding: '16px',
        borderTop: `1px solid ${ABLE_COLORS.secondary}`,
        backgroundColor: 'white',
        flexShrink: 0
      }}
    >
      <div style={{ display: 'flex', gap: '8px' }}>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          onFocus={onFocus}
          placeholder="Ask about your tasks..."
          disabled={isLoading}
          style={{
            flex: 1,
            padding: '12px',
            border: `1px solid ${ABLE_COLORS.secondary}`,
            borderRadius: '8px',
            fontSize: '16px', // 16px prevents iOS zoom on focus
            outline: 'none'
          }}
        />
        <button
          onClick={onSend}
          disabled={!value.trim() || isLoading}
          style={{
            padding: '12px 16px',
            backgroundColor: ABLE_COLORS.primary,
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: value.trim() && !isLoading ? 'pointer' : 'not-allowed',
            opacity: value.trim() && !isLoading ? 1 : 0.5
          }}
        >
          <Send size={20} />
        </button>
      </div>
    </div>
  );
}
